module.exports = __webpack_public_path__ + "static/media/cate-edu.70bea071.png";